import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link'
import cName from "classnames";
import styles from './index.module.scss';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Wrapper from '@/components/wrapper';
import classNames from 'classnames';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import request from '@/utils/request';

interface IProps {

}
export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data } = await request.get(`/api/get_gallery_list`, {
    params: {
      category_id: 13
    }
  })
  return {
    props: {
      ...res.props,
      data: data?.data || null
    }
  }
}

const Photo: NextPage<IProps> = ({ menuDetail, data }: any) => {
  const router = useRouter();
  const t = useTranslations("schedule.event4");

  useEffect(() => {
    setTimeout(() => {
      const str = document.getElementById("reactCode")?.innerText || 'console.log()';
      eval(str)
    }, 0);
  }, [menuDetail]);
  return (
    <div>
      <Wrapper>
        <div className={cName([styles.container, 'm-1600'])}>
          {getHead(menuDetail)}
          <div dangerouslySetInnerHTML={{ __html: menuDetail?.info?.content }} />
          <div className={styles.photo}>
            <h3>{t('subtitle')}</h3>
            {!!data?.list?.length && <div className={styles.photoList}>
              <div className={styles.top}>
                <img src={data?.list[0]?.photo} alt={data?.list[0]?.[`brief_${router.locale}`]} />
                <div>
                  <img src={data?.list[1]?.photo} alt={data?.list[1]?.[`brief_${router.locale}`]} />
                  <img src={data?.list[2]?.photo} alt={data?.list[2]?.[`brief_${router.locale}`]} />
                </div>
                <img src={data?.list[3]?.photo} alt={data?.list[3]?.[`brief_${router.locale}`]} />
              </div>
              <div className={styles.bottom}>
                <div>
                  <img src={data?.list[4]?.photo} alt={data?.list[4]?.[`brief_${router.locale}`]} />
                  <img src={data?.list[5]?.photo} alt={data?.list[5]?.[`brief_${router.locale}`]} />
                </div>
                <img src={data?.list[6]?.photo} alt={data?.list[6]?.[`brief_${router.locale}`]} />
                <img src={data?.list[7]?.photo} alt={data?.list[7]?.[`brief_${router.locale}`]} />
                <img src={data?.list[8]?.photo} alt={data?.list[8]?.[`brief_${router.locale}`]} />
              </div>
            </div>}
            <Link href="/media/photo">
              <a>
                <div className={classNames([styles.more, 'btnStyle'])}>
                  <span>{t('more')}</span>
                  {/* @ts-ignore */}
                  <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                    <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                    </path>
                  </svg>
                </div>
              </a>
            </Link>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default Photo;
